<template>
  <GbButton
    gb-theme="aiSecondary"
    :class="['w-full', extraClasses]"
    :disabled="disabled"
    :tooltip-text="disabled ? DISABLED_TOOLTIP : ''"
    :aria-description="disabled ? DISABLED_TOOLTIP : ''"
    @click="handleClick"
    size="xs"
  >
    <span
      v-if="hasExistingResults"
      class="material-icons-round text-xl mr-1 bg-gradient-to-r from-ai-bluePinkStart to-ai-bluePinkStop bg-clip-text text-transparent text-fill-transparent"
      aria-hidden="true"
    >replay</span>
    <span
      v-else
      class="material-icons-outlined text-xl mr-1 bg-gradient-to-r from-ai-bluePinkStart to-ai-bluePinkStop bg-clip-text text-transparent text-fill-transparent"
      aria-hidden="true"
    >assignment_turned_in</span>
    <span>Auto-review</span>
    <span v-if="showCriteriaSetName && criteriaSetName" class="font-normal opacity-70 ml-1">({{ criteriaSetName }})</span>
  </GbButton>
</template>

<script setup lang="ts">
import GbButton from '@/components/GbButton.vue'

const DISABLED_TOOLTIP = 'Add a Strengths & Needs or Impact statement to enable Auto-review'

withDefaults(defineProps<{
  criteriaSetName?: string
  hasExistingResults?: boolean
  disabled?: boolean
  extraClasses?: string
  showCriteriaSetName?: boolean
}>(), {
  criteriaSetName: '',
  hasExistingResults: false,
  disabled: false,
  extraClasses: '',
  showCriteriaSetName: true
})

const emit = defineEmits<{ click: [] }>()

function handleClick(event?: MouseEvent) {
  event?.stopPropagation()
  emit('click')
}
</script>

<style scoped>
.text-fill-transparent {
  -webkit-text-fill-color: transparent;
}
</style>
